/**
 * jsonMergeUtil_OverridePermissions.ts - Key override permission checking
 * Port of C# JsonMergeUtil_OverridePermissions.cs
 * Pure ES Module version
 */

import { JsonObject } from '../../app/json/jsonValue.js';

// [Dafny Verified] Properties O1-O5 — Verification/dafny/src/CanOverrideKey.dfy
/**
 * Checks if configJson is allowed to override a template key.
 * Phase 1: Check presence of {Key}_AllowedRoles or global AllowedRoles in templateJson
 * Phase 2 (future): Validate actual user role against AllowedRoles value
 */
export function canOverrideKey(key: string, templateJson: JsonObject, contextJson: JsonObject | null): boolean {
    // Rule 1: Cannot override if key exists in contextJson (server values always win)
    if (contextJson != null && contextJson.has(key)) {
        return false;
    }

    // Rule 2: Cannot override if key doesn't exist in templateJson (no new keys from client)
    if (!templateJson.has(key)) {
        return false;
    }

    // Rule 3: Check for AllowedRoles permission (field-specific first, then global)
    const fieldAllowedRolesKey = key + '_AllowedRoles';

    // Phase 1: Presence check only
    // Check field-specific permission first (takes precedence)
    if (templateJson.has(fieldAllowedRolesKey)) {
        // Field-specific exists - check if it's not empty (empty = explicitly denied)
        const fieldValue = templateJson.get(fieldAllowedRolesKey);
        let fieldValueStr = '';
        if (fieldValue != null) {
            fieldValueStr = String(fieldValue);
        }
        return fieldValueStr !== '';
    }

    // Fall back to global AllowedRoles
    if (templateJson.has('AllowedRoles')) {
        const globalValue = templateJson.get('AllowedRoles');
        let globalValueStr = '';
        if (globalValue != null) {
            globalValueStr = String(globalValue);
        }
        return globalValueStr !== '';
    }

    // No permission granted
    return false;
}
